(function () {
  const COOKIE_CHOICE = 'geo_redirect_choice';
  const COOKIE_CHECKED = 'is_geo_redirect_checked';
  const COOKIE_DAYS = 7;

const GEO_REDIRECTS = [

  // Canada
  {
    country_code: 'CA',
    country_name: 'Canada',
    redirect_link: 'https://baybloorradio.com/',
  },

  // Korea
  {
    country_code: 'KR',
    country_name: 'South Korea',
    redirect_link: 'https://www.soundcat.co.kr/',
  },

  // United Kingdom
  {
    country_code: 'GB',
    country_name: 'United Kingdom',
    redirect_link: 'https://www.electromod.co.uk/',
  },

  // Singapore
  {
    country_code: 'SG',
    country_name: 'Singapore',
    redirect_link: 'https://jaben.com',
  },

  // Thailand
  {
    country_code: 'TH',
    country_name: 'Thailand',
    redirect_link: 'https://www.munkonggadget.com/',
  },

  // Hong Kong
  {
    country_code: 'HK',
    country_name: 'Hong Kong',
    redirect_link: 'https://soundwaveaudio.com.hk/',
  },

  // Finland
  {
    country_code: 'FI',
    country_name: 'Finland',
    redirect_link: 'https://tur-pex.com/',
  },

  // Japan
  {
    country_code: 'JP',
    country_name: 'Japan',
    redirect_link: 'https://www.aiuto-jp.co.jp/',
  },
];

  console.log(GEO_REDIRECTS, 'GEO_REDIRECTS');

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
  }

  if (getCookie(COOKIE_CHECKED)) return;

  setCookie(COOKIE_CHECKED, 'true', COOKIE_DAYS);

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then((res) => res.json())
    .then((data) => {
      if (!data || !data.country_code) return;

      const match = GEO_REDIRECTS.find((item) => item.country_code === data.country_code);

      if (!match || !match.redirect_link) return;

      // If user already accepted/declined before
      if (getCookie(COOKIE_CHOICE)) return;

      const modal = document.getElementById('geoModal');
      const text = document.getElementById('geoText');
      const accept = document.getElementById('geoAccept');
      const decline = document.getElementById('geoDecline');
      const closeBtn = document.getElementById('geoClose');

      if (!modal || !text || !accept || !decline || !closeBtn) return;

      text.innerHTML = `
        We noticed you are visiting from <strong>${match.country_name}</strong>.<br>
        Would you like to continue on our local website?
      `;

      setTimeout(() => {
        modal.style.display = 'flex';
      }, 5000);

      function closeModal(choice = 'declined') {
        setCookie(COOKIE_CHOICE, choice, COOKIE_DAYS);
        modal.style.display = 'none';
      }

      accept.onclick = function () {
        closeModal('accepted');
        window.open(match.redirect_link, '_blank');
      };

      decline.onclick = () => closeModal('declined');
      closeBtn.onclick = () => closeModal('declined');
    })
    .catch((err) => console.error('Geo lookup failed', err));
})();

